export default function formatCurrency(value) {
  // toLocaleString adds commas
  return `$${value.toLocaleString()}`;
}
